module.exports = __webpack_public_path__ + "images/index/img03.e143fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/shmei/img03.png
// module id = 8I4C
// module chunks = 21